/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  CartEventModule,
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
} from '@spartacus/core';
import {
  ActiveFacetsModule,
  CardModule,
  FacetListModule,
  FormErrorsModule,
  GenericLinkModule,
  GlobalMessageComponentModule,
  IconModule,
  ItemCounterModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  ProgressButtonModule,
} from '@spartacus/storefront';
import { AddEkWishListModule } from '../../../wish-list/add-ek-wishlist/add-ek-wishlist.module';
import { CartOrderSummaryModule } from '../../order-summary/order-summary.module';
import { AddToEkcartComponent } from './add-to-ekcart.component';

@NgModule({
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    FacetListModule,
    FormsModule,
    ReactiveFormsModule,
    FormErrorsModule,
    ActiveFacetsModule,
    IconModule,
    I18nModule,
    UrlModule,
    RouterModule,
    GenericLinkModule,
    MediaModule,
    CardModule,
    ProgressButtonModule,
    GlobalMessageComponentModule,
    CartOrderSummaryModule,
    ItemCounterModule,
    AddEkWishListModule,
    CartEventModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductAddToCartComponent: {
          component: AddToEkcartComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        ProductAddToCartComponent: AddToEkcartComponent,
      },
    }),
  ],
  exports: [AddToEkcartComponent],
  declarations: [AddToEkcartComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddToEkCartModule {}
